module.exports = __webpack_public_path__ + "img/chalk_8.8e2258cf.png";